

import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedOption, addResumenData, removeResumenData, updateDominioPrincipal } from '../../globalslice';
import '../../styles/Transferencia.scss';
import { useTranslation } from 'react-i18next';
import bsqicon from '../../images/bsq-icon.svg';
import bsqicon2 from '../../images/bsq-icon-orange.svg';
import loadingIcon from '../../images/loading.png';
import getNoDomain from '../../services/NoDomainInfo';
import validateAlreadyExistInCart from '../../helpers/validateAlreadyExistInCart';
import validateAndCleanDomain from '../../helpers/validateAndCleanDomain';

const DominioNo = () => {
  const selectedOption = useSelector((state) => state.global.selectedOption);
  const resumenData = useSelector((state) => state.global.ResumenData);
  const [dominioNo, setdominioNo] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [icon, setIcon] = useState(bsqicon);
  const [inputError, setInputError] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [msgresult, setMessageResult] = useState('green');
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleOptionChange = (option) => {
    dispatch(setSelectedOption(option));
    if(option == 'opc-no'){
      resumenData.forEach(element => {
        if(element.actual && element.type != 'domain'){
          dispatch(updateDominioPrincipal({ id: element.id, dominioPrincipal:null, domainType: null }));
        } else if(element.actual && element.type == 'domain'){
          dispatch(removeResumenData(element.id));
        }
      });
      setdominioNo("");
      setMessage(null);
      setIsValid(true);
      setInputError('');
      setMessageResult('green');
    }
  };

  const handleNoDominio = async() => {
    // const isValidDomainValue = isValidDomain(dominioNo);
    setIsValid(true); 
    let domMod = null;
    if (dominioNo.trim() === '') {
      setInputError(true);
      return;
    }
    domMod = dominioNo;
    setMessage(null);

    setInputError(false);
    setLoading(true);
    try {
      if (domMod != null) {

        setMessage(null);

        //validate the domain and set the state of dominio
        let domain_clean = await handleValidateDomain(domMod);

        //if the domain is not valid, show an error message and return
        if (!domain_clean) {
          setIsValid(false);
          setMessage(t('cart.config.domain.not_valid'));
          setMessageResult('red');
          setLoading(false);
          return;
        }

        domMod = domain_clean;

        //Validate if the domain already exists in the cart
        let domainExists = validateAlreadyExistInCart(resumenData, domMod);

        if (domainExists) {
          // If the domain already exists in the cart, stop the flow and show the message
          setMessageResult('red');
          setMessage(t('cart.config.domain.already_exist'));
          setLoading(false);
          return; // Leave the flow
        }
        const resNoDomain = await getNoDomain({ domMod });
        const isSuccess = resNoDomain.result === 'success';

        // Actualizar los datos según el resultado
        resumenData.forEach(element => {
          if (element.actual && element.type !== 'domain') {
            dispatch(updateDominioPrincipal({
              id: element.id,
              dominioPrincipal: isSuccess ? domMod : null,
              domainType: 'nodomain',
            }));
          }
        });
        
        setMessageResult(resNoDomain.classerror);
        setMessage(resNoDomain.message);
        if (isSuccess) {
          setLoading(false);
          return;
        } else {
          setInputError(true);
        }
      } else {
        setInputError(true);
    
        // Actualizar los datos para el caso de domMod === null
        resumenData.forEach(element => {
          if (element.actual && element.type !== 'domain') {
            dispatch(updateDominioPrincipal({
              id: element.id,
              dominioPrincipal: null,
              domainType: 'nodomain',
            }));
          }
        });
      }
    } catch (error) {
      setMessage('Error al buscar la información del dominio.');
    } finally {
      setLoading(false);
    }
  };

  function isValidDomain(domain) {
    // Expresión regular para validar un dominio sin www y con extensiones de 2 a 3 caracteres
    const domainPattern = /^(?!www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,}){1,}$/;
    return domainPattern.test(domain);
  }

  /**
 * This function validates the domain and returns the cleaned domain or null if it is not valid furhermore sets the state of domain
 * @param {*} domain 
 * @returns result or null
 */
  const handleValidateDomain = async (domain) => {
    const result = validateAndCleanDomain(domain, true, false);
    if (!result.isValid) {
      return null; // Return null if not valid
    }
    setdominioNo(result.cleanDomain); // Set the state of domain

    return result.cleanDomain; // Return the cleaned domain
  };

  return (
    <div className={`bsq-dominio  ${selectedOption === 'opc-no' ? 'active' : ''}`}>
      <div className='bsq-radio'>
        <input
          type="radio"
          className=""
          name="sel-type"
          id="opc-no"
          checked={selectedOption === 'opc-no'}
          onChange={() => handleOptionChange('opc-no')}
        />
        <label className="opc-busqueda" htmlFor="opc-no">{t('cart.config.domain.no_domain.label')}</label>
        <div className={`${selectedOption !== 'opc-no' ? 'bsq-hidden' : ''}`}>
          <div className='bsq-buscador'>
            <div className="input-container" >
              <img src={icon} alt="Icon Busqueda" className="bsq-search-icon" />
              <input
                type="text"
                id="bsq-input-dominio"
                className={`form-control bsq-dominio-input ${!isValid || inputError != '' ? 'input-error' : ''}`}
                value={dominioNo}
                placeholder={t('cart.config.domain.no_domain.placeholder')}
                onChange={(e) => {
                  setdominioNo(e.target.value);
                  setInputError(false);
                }}
                onFocus={() => setIcon(bsqicon2)} 
                onBlur={() => setIcon(bsqicon)} 
              />
            </div>
            <button className="bsq-btn-buscar" onClick={handleNoDominio}>{t('cart.config.domain.no_domain.btn')}</button>
          </div>
          <div>
            {loading &&
              <div className='bsq-load'>
                <img src={loadingIcon} alt="Cargando..." className="bsq-load-icon" />
              </div>
            }
            {message &&
              <p className={`transfer-msg ${msgresult}`}>{message}</p>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default DominioNo;
